import {DtoDetailConfigurable} from "../../../../../core/shared/dto/dto-detail-configurable";
import {BillingAreaStatusInternal} from "../../../enum/billing-area-status-internal.enum";

export class BillingAreaDto extends DtoDetailConfigurable{


    public name: string;
    public status: BillingAreaStatusInternal;
    public description: string;

    // Technical name allocation (WP-1 / H-1) — CcNumberRange used to generate the account name
    public numberRangeDtoId: number;
    public numberRangeDtoName: string;
    public accountNameTemplate: string;
    public accountNamePreview: string;

}